import { render, staticRenderFns } from "./ConfirmPassport.vue?vue&type=template&id=01f33aab&scoped=true&"
import script from "./ConfirmPassport.vue?vue&type=script&lang=js&"
export * from "./ConfirmPassport.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmPassport.vue?vue&type=style&index=0&id=01f33aab&prod&lang=css&"
import style1 from "./ConfirmPassport.vue?vue&type=style&index=1&id=01f33aab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f33aab",
  null
  
)

export default component.exports